// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Counter_wrapper__gu26B","small":"Counter_small__eu6ZJ","icon":"Counter_icon__Tnkqq","count":"Counter_count__d4P4J"};